module.exports = __webpack_public_path__ + "img/39.502f1f3a.jpg";